import { connect } from 'react-redux';

import ProfileView from './view.jsx';
import { updateUserProfile } from 'src/redux/actions/users.ts';


const mapStateToProps = (state, ownProps) => {
  return {
    account: state.accounts.item,
    user: state.users.me,
    updatingProfileSuccess: state.users.updation.updated,
    updatingProfile:  state.users.updation.updating
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateUserProfile: (request) => {
      dispatch(updateUserProfile(request));
    }
  }
}


const ProfilePage = connect (
    mapStateToProps,
    mapDispatchToProps
)(ProfileView);

export default ProfilePage;